// @flow
import rnTheme from '../../native/themes/defaultTheme';
import browserTheme from '../../browser/themes/defaultTheme';

const theme = process.env.IS_REACT_NATIVE === '1'
  ? rnTheme
  : browserTheme;

export default theme;
